import {
  ApacCandidateHeaderFooterLinkProvider,
  ApacCandidateFooter,
} from '@seek/apac-candidate-header-footer';
import { Link } from 'braid-design-system';

import type { ApacHeaderFooterAuthenticationStatus } from '../App/App';

interface FooterProps {
  authenticationStatus: ApacHeaderFooterAuthenticationStatus;
}

const Footer = ({ authenticationStatus }: FooterProps) => {
  const customLinkComponent = {
    Link: (props: any) => <Link {...props} />,
    sendLinkEvent: () => {},
  };

  return (
    <ApacCandidateHeaderFooterLinkProvider value={customLinkComponent}>
      <ApacCandidateFooter
        isExpandedVersion={true}
        authenticationStatus={authenticationStatus}
        widthMode="large"
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};

export default Footer;
